// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { ITranslationTable } from '../EnumClass';

export const name: ITranslationTable = {
  /* eslint-disable max-len */
  Freeform: (t, data?, options?) => t('enum.quiz-type.freeform.name', data, options),
  MultiChoice: (t, data?, options?) => t('enum.quiz-type.multi-choice.name', data, options),
  MultiChoiceMany: (t, data?, options?) => t('enum.quiz-type.multi-choice-many.name', data, options),
  Pool: (t, data?, options?) => t('enum.quiz-type.pool.name', data, options),
  PoolMany: (t, data?, options?) => t('enum.quiz-type.pool-many.name', data, options),
  /* eslint-enable max-len */
};
